import { render, staticRenderFns } from "./resourceDetails.vue?vue&type=template&id=340e6728&"
import script from "./resourceDetails.vue?vue&type=script&lang=js&"
export * from "./resourceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports